export default __webpack_public_path__ + "static/media/payment-icon-2.7fd6ac27.svg";